export const todayLocal = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const formatMMDDYYYY = (dateStr) => {
  if (!dateStr) return '';
  const [yyyy, mm, dd] = dateStr.split("-");
  return `${mm}/${dd}/${yyyy}`;
};

export const formatDateForInput = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const formatHillTime = (seconds) => {
  const total = Number(seconds || 0);
  if (!Number.isFinite(total) || total <= 0) return '0:00';
  const mins = Math.floor(total / 60);
  const secs = Math.floor(total % 60);
  return `${mins}:${String(secs).padStart(2, '0')}`;
};

export const getPerformanceClass = (value, type) => {
  if (type === 'kd') {
    if (value >= 1.5) return 'performance-excellent';
    if (value >= 1.2) return 'performance-good';
    if (value >= 1.0) return 'performance-average';
    return 'performance-poor';
  }
  if (type === 'score') {
    if (value >= 4000) return 'performance-excellent';
    if (value >= 3000) return 'performance-good';
    if (value >= 2000) return 'performance-average';
    return 'performance-poor';
  }
  return '';
};

